import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const TitleAndMetaTags = ({ title, ogDescription, canonicalUrl, lang }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
    >
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:image" content="/dbsystem-icon.png" />
      <meta name="author" content={site.siteMetadata.author} />
      <meta
        name="description"
        content={ogDescription || site.siteMetadata.description}
      />
      <meta
        property="og:description"
        content={ogDescription || site.siteMetadata.description}
      />

      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  )
}

TitleAndMetaTags.defaultProps = {
  lang: `en`,
}

TitleAndMetaTags.propTypes = {
  title: PropTypes.string.isRequired,
  canonicalUrl: PropTypes.string.isRequired,
  ogDescription: PropTypes.string,
  lang: PropTypes.string,
}

export default TitleAndMetaTags
